import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import Home from '@/view/Home'
import qrcode from '@/view/qrcode'
import newlist from '@/view/newlist'
import getjson from '@/view/getjson'
import choose from '@/view/choose'
Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      redirect:'/newlist',
      children:[
        {
          path: 'Home',
          name: 'Home',
          component: Home
        },
        {
          path: 'qrcode',
          name: 'qrcode',
          component: qrcode
        },
        {
          path: 'newlist',
          name: 'newlist',
          component: newlist
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js